import { BaseModel } from "sjs-base-model";
import OneOffsStatDataItemModel from "./OneOffsStatDataItemModel";
import OneOffsStatSummaryModel from "./OneOffsStatSummaryModel";

// Returned Api Data sample
// const example = {
//     data: [
//         {
//             created: "2021-12-31T17:32:28Z",
//             orderId: 5,
//             state: "Completed",
//             company: "Doe Ltd.",
//             firstName: "John",
//             lastName: "Doe",
//             email: "john@doe.com",
//             productCategoryName: "Market data stream files",
//             productName: "Eurex EOBI Enhanced Orderbook Interface File",
//             from: 20220101,
//             to: 20220131,
//             price: 1875,
//             remark: "Important remark"
//         }
//     ],
//     summary: {
//         totalSale: 22138,
//         noTransactions: 12,
//         uniqueUsers: 6
//     }
// };

export default class OneOffsStatDataModel extends BaseModel {
    data = [OneOffsStatDataItemModel];
    summary = [OneOffsStatSummaryModel];

    constructor(data) {
        super();
        this.update(data);
    }
}
